<template>
    <v-container class="padding-top-0 padding-bootom-0">
        <v-row>
            <v-col cols="12" class="padding-top-0 padding-bootom-0 pl-0">
                <v-card class="pb-0">
                    <v-card-text class="pb-0">
                        <v-tabs v-model="section">
                            <v-tabs-slider></v-tabs-slider>
                            <v-tab href="#tab-datos">
                                Pedido
                            </v-tab>
                            <v-tab href="#tab-historico" v-if="verifyPermission('ver_historico_venta')">
                                Histórico
                            </v-tab>

                            <v-tab-item value="tab-datos">
                                <div class="d-flex d-sm-none btn-xs-actions">
                                    <template v-if="order !== null && section === 'tab-datos'">
                                        <div class="pt-3 mr-3 pb-3" style="border-bottom: 1px solid;">
                                            <v-btn block v-for="status in availableStatus" :key="status.id" class="mr-2 mt-2" style="width:100%;"
                                                outlined small dark 
                                                :color="statusColor[status.name.toLowerCase().replace(' ', '_')]"
                                                @click="handleChangeStatus(status)">
                                                {{ status.action_name }}
                                            </v-btn>
                                            <v-btn outlined small class="mr-2 mt-2" style="width:100%;">
                                                Editar
                                            </v-btn>
                                        </div>                                
                                    </template>
                                </div>
                                <detail-order v-if="order !== null"></detail-order>
                                <div v-else class="pt-3 pb-3">
                                   <h2>Seleccione un pedido</h2>
                                </div>
                            </v-tab-item>
                            <v-tab-item value="tab-historico">
                                <History v-if="order !== null"></History>
                                <div v-else class="pt-3 pb-3">
                                   <h2>Seleccione un pedido</h2>
                                </div>
                            </v-tab-item>
                            <v-spacer></v-spacer>
                            <template v-if="order !== null && section === 'tab-datos'">
                                <div class="pt-3 mr-3 d-none d-sm-flex d-md-flex d-lg-flex d-xl-flex" 
                                    style="border-bottom: 1px solid;"
                                    v-if="verifyPermission('cambiar_estado_venta')">
                                    <v-btn v-for="status in availableStatus" :key="status.id" class="mr-2" 
                                        outlined small dark 
                                        :color="statusColor[status.name.toLowerCase().replace(' ', '_')]"
                                        @click="handleChangeStatus(status)">
                                        {{ status.action_name }}
                                    </v-btn>
                                    <v-btn outlined small @click="handleEditOrder" v-if="order.status=='Registrado'">
                                        Editar
                                    </v-btn>
                                </div>                                
                            </template>
                        </v-tabs>                        
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <payment-form ref="paymentForm"/>
    </v-container>
    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import router from '@/router/index'

import OrdersTools from '../../helpers/OrdersTools.js'
import PaymentTools from '../../helpers/PaymentTools.js'
import CartTools from '../../helpers/CartTools.js'

import DetailOrder from './DetailOrder'
import History from './History'
import PaymentForm from '../../components/Payment/PaymentForm'

import {APIService} from '@/APIService';
const apiService = new APIService();

export default {
    name: 'Information',
    components: {
        DetailOrder,
        PaymentForm,
        History
    },
    data() {
        return {
            section: null,
            statusColor: {
                registrado: 'grey darken-1',
                anulado: 'red darken-1',
                pagado: 'green darken-1',
                entregado: 'blue darken-1',
                en_reparto: 'amber darken-1',
            },
            user: null,
            is_delivery_man: false,
        }
    },
    computed: {
        ...mapState('cash', [
            'cashCurrent'
        ]),
        ...mapState('orders', [
            'order',
            'listStatus',
            'availableStatus',
            'deliveryman',
            'finalDeliveryman'
        ]),
        ...mapState('payment', [
            'listProducts',
            'amount_igv'
        ]),
        ...mapState('sales', [
            'orderId'
        ]),
        ...mapState('mobilities', [
            'can_attend'
        ])
    },
    methods: {
        ...mapActions('orders', [
            'selectOrder',
            'getAvailableStatus',
            'assignDeliveryman',
            'assignFinalDeliveryman',
            'replaceOrderUpdated',
            'getDeliveryUsers'
        ]),
        ...mapActions('payment', [
            'runSetListProducts',
            'runSetCustomer',
            'runSetOrderIdPay',
            'runSetSubtotal',
            'runSetTotal',
            'runSetAmountIgv'
        ]),
        ...mapActions('sales', [
            'runAddProductFromOrderEdit',
            'clearData',
            'runSetBuyerId',
            'selectBuyer',
            'runSetOrderId'
        ]),
        ...mapActions('mobilities', [
            'canAttendOrder',
            'emptyData'
        ]),
        handleChangeStatus(newStatus){
            this.emptyData();
            let new_status_name = newStatus.name.toLowerCase();
            let optionStatus = ['en reparto', 'entregado', 'anulado'];
            let statusVerifyStock = ['entregado', 'pagado'];
            if(newStatus.name.toLowerCase() === 'en reparto' && this.deliveryman === -1) {
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'ERROR',
                    text: 'Debe asignar un repartidor!'
                });
            } else{
                if (this.order.status.toLowerCase() == 'en reparto') {
                    if (!this.existCashOpen(newStatus)) {
                        this.$swal({
                            text: "Caja esta cerrada, no puede realizar pago.",
                            type: "warning",
                            showCancelButton: false,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Aceptar"
                        });
                    } else {
                        if (statusVerifyStock.includes(new_status_name)) {
                            this.verifyStock(this.order, newStatus);
                        } else {
                            this.prepareToChangeStatus(newStatus);
                        }
                    }
                } else {
                    this.prepareToChangeStatus(newStatus);
                }
            }
        },
        prepareToChangeStatus(newStatus) {
            let optionStatus = ['en reparto', 'entregado', 'anulado'];
            if (optionStatus.includes(newStatus.name.toLowerCase())){
                this.changeStatus(newStatus)
            } else if(newStatus.name.toLowerCase() === 'pagado'){
                this.runSetOrderIdPay(null)
                this.runSetOrderIdPay(this.order.id)
                this.runSetSubtotal(this.order.subtotal)
                this.runSetAmountIgv(this.order.igv)
                this.runSetTotal(this.order.total)
                this.runSetListProducts([])
                this.runSetListProducts(PaymentTools.prepareProductList('orders', this.order.products))
                this.runSetCustomer(this.order.customer)
                this.$refs.paymentForm.showForm()
            }
        },
        changeStatus(newStatus){
            this.$swal({
                    title: "¿Desea confirmar?",
                    text: "Confirma que desea cambiar el estado a: " + newStatus.name,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Confirmar",
                    cancelButtonText: "Cancelar",
                }).then((result) => {
                    if(result.value){
                        if(result.value === true){
                            let orderChange = {
                                order_id: this.order.id,
                                status: newStatus.name,
                                deliveryman: this.deliveryman,
                                final_deliveryman: this.final_deliveryman
                            }
                            apiService.changeStatusOrder(orderChange).then((response) => {
                                this.selectOrder(null)
                                this.getDeliveryUsers()
                                this.selectOrder(response.data)
                                this.getAvailableStatus()
                                if (this.order.deliveryman !== null) {
                                    this.assignDeliveryman(this.order.deliveryman)
                                } else {
                                    this.assignDeliveryman(-1)
                                }
                                this.replaceOrderUpdated()
                                this.$notify({
                                    group: 'foo',
                                    type: 'success',
                                    title: 'RESULTADO DE ACCIÓN REALIZADA',
                                    text: 'El cambio de estado se realizó de manera correcta!'
                                });
                            });
                        }
                    }                    
                })
        },
        handleEditOrder(){
            this.clearData()
            
            this.runSetOrderId(this.order.id)            
            this.runSetBuyerId(this.order.customer.id)
            this.selectBuyer()

            let orderProducts = this.order.products
            
            orderProducts.forEach(element => {
                let productItem = {
                    id: element.id,
                    name: element.name,
                    unit_price: element.unit_price,
                    wholesale_price: element.wholesale_price,
                    preferential_price: element.preferential_price,
                    base_price: element.pivot.base_price,
                    price: element.pivot.base_price * element.pivot.quantity,
                    discount_type: element.pivot.discount_type,
                    discount_amount: element.pivot.discount_amount,
                    quantity: element.pivot.quantity
                }
                productItem.price = CartTools.calculatePriceFromProductItem(productItem)
                this.runAddProductFromOrderEdit(productItem)                
            });
            router.push('/sales')
        },
        setDataUser(){
            this.user = this.$identifiedUser()
            this.is_delivery_man = this.$isDeliveryMan()
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        },
        async verifyStock(order, newStatus){
            let delivery_user = (order.final_deliveryman) ? order.final_deliveryman : order.deliveryman;
            if (delivery_user) {
                await this.canAttendOrder({
                    user_id: delivery_user,
                    order_id: order.id
                });
                if (!this.can_attend) {
                    this.$swal({
                        text: "No cuenta con stock suficiente para entregar pedido.",
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Aceptar"
                    });
                } else {
                    this.prepareToChangeStatus(newStatus);
                }
            }
        },
        existCashOpen (newStatus) {
            let exist = true;
            if (newStatus.name.toLowerCase() == 'pagado') {
                if (this.cashCurrent == null || this.cashCurrent == '') {
                    exist = false;
                }
            }
            return exist;
        }
    },
    mounted() {
        this.setDataUser()
        this.clearData()
        this.selectOrder(null)
        this.emptyData();
    }
}
</script>

<style>
.btn-xs-actions{
    justify-content: flex-end;
}

</style>